/**
 * Whether a formula from a form rule may be evaluated.
 *
 * The rule strings come from the form classes (app/Forms), but the substituted values come from
 * user input - and whether anything is calculated is decided after substitution
 * (formConfig.js: calculateRule). Without this check every input containing an arithmetic
 * character is evaluated as an expression.
 *
 * What is checked is not the meaning but the alphabet: digits, arithmetic characters, parentheses
 * and the functions listed by name. The names are listed individually and not as Math\.\w+,
 * otherwise Math.max.constructor would make arbitrary code reachable.
 */
const ALLOWED_CHARACTERS = /^(?:\s|\d|[.,+\-*/()]|Math\.(?:floor|ceil|round|abs|min|max))+$/

export function isSafeFormExpression(expression) {
    return ALLOWED_CHARACTERS.test(String(expression))
}
